module.exports = __webpack_public_path__ + "static/media/shape_two.94c3c37d.png";